import { actionFactory } from 'redux/factories';
import { types } from './types';

export const login = actionFactory(types.LOGIN);
export const logout = actionFactory(types.LOGOUT);
export const getUser = actionFactory(types.GET_USER);
